export class InterpolatedChart {
  type: string;
  interpolatedChartData: any[] = [];
}
